/**
 * Global Helper: Select
 * ----------------------------------------------------------
 * Used to customize the look of select dropdowns
 * 
 * Package dependency: choices.js 
 * (https://www.npmjs.com/package/choices.js?ref=vanillalist)
 * ----------------------------------------------------------
 */
/* eslint-disable */
import { registerLegacySalvoLiteComponent, legacySalvoLiteLog as log } from '@eastsideco/salvo-ts';
import Choices from 'choices.js';

/**
 * Component class 
 */
class Select {
    constructor(theme, elem) {
        this._theme = theme;
        this._elem = elem;
        this._choices = null;
        this._observer = null;
        log.debug(this.constructor.name, 'Constructed', this);
    }

    onInit() {
        this.buildChoices();
        this.initObserver();
    }

    buildChoices(select) {
        const _options = {
            searchEnabled: false,
            removeItems: false,
            paste: false,
            itemSelectText: '',
            shouldSort: false,
            ...JSON.parse(this._elem.getAttribute('[data-select]') || '{}')
        };

        let _selectElem = this._elem.querySelector('select');
        if (select) {
            _selectElem = select;
        }

        if (!_selectElem) return;

        // Prevent re-initialization if Choices is already applied
        if (_selectElem.dataset.choicesInitialized === 'true') {
            return;
        }

        this._choices = new Choices(_selectElem, _options);
        _selectElem.dataset.choicesInitialized = 'true';
    }

    initObserver() {
        this._observer = new MutationObserver(() => {
            const select = this._elem.querySelector('select');
            if (!select) return;
            this.buildChoices(select);
        });

        this._observer.observe(this._elem, {
            subtree: true,
            childList: true
        });
    }
}

/**
 * Export Call
 */
export default registerLegacySalvoLiteComponent({
    component: Select,
    selector: '[data-select-wrapper]', // Required
});
